<template>
  <div class="text-center pa-4">
    <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
    <p v-if="loading">Processing Google login...</p>
    <p v-if="error" class="error--text">{{ error }}</p>
    <p v-if="!loading && !error">Login successful! Redirecting...</p>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';

export default {
  setup() {
    const loading = ref(true);
    const error = ref(null);
    const authStore = useAuthStore();
    const router = useRouter();

    onMounted(async () => {
      try {
        // Call fetchUserStatus from auth store which handles CSRF token
        const success = await authStore.fetchUserStatus();
        
        if (success) {
          // Short timeout to show success message before redirect
          setTimeout(() => {
            loading.value = false;
            router.push({ name: 'Home' });
          }, 1000);
        } else {
          throw new Error('Failed to retrieve user session');
        }
      } catch (err) {
        console.error('Error processing Google login:', err);
        error.value = 'Login failed. Please try again.';
        loading.value = false;
        
        // Redirect to login after showing error briefly
        setTimeout(() => {
          router.push({ name: 'Login' });
        }, 2000);
      }
    });

    return {
      loading,
      error
    };
  }
};
</script>